import { Checkbox } from "@progress/kendo-react-inputs";

export const HorizontalDisplayProperty = {
  propertyName: "HorizontalDisplay",
  propertyDisplay: "Display Horizontally?",
  propertyType: "boolean",
  propertyCategory: "Layout",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Checkbox
        name={this.propertyName}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || false}
      />
    );
  },
};
